import React from "react";
import TableComponent from "./TableComponent";
import FillquestionComponent from "./FillquestionComponent";
import FilltextComponent from "./FilltextComponent";
import MultipleChoiceComponent from "./MultipleChoiceComponent";
import ResearchComponent from "./ResearchComponent";
import ExerciseGroupComponent from "./ExerciseGroupComponent";
import QuestionSentenceComponent from "./QuestionSentenceComponent";
import {FilltextListComponent} from "./FilltextListComponent";
import QuestionkeywordsComponent from "./QuestionkeywordsComponent";
import SortlistComponent from "./SortlistComponent";
import DefaultComponent from "./DefaultComponent";
import OneCheckboxComponent from "./OneCheckboxComponent";

export default function ComponentFactory(props) {
    var ResultComponent = null;
    let extraParams = {}
    switch (props.exercise?.type) {
        case "fillquestion":
            ResultComponent = FillquestionComponent;
            break;
        case "filltext":
            ResultComponent = FilltextComponent;
            break;
        case "filltextlist":
            ResultComponent = FilltextListComponent;
            break;
        case "multiplechoice":
            ResultComponent = MultipleChoiceComponent;
            switch (props.exercise?.subtype) {
                case "onecheckbox":
                    ResultComponent = OneCheckboxComponent;
                    break
                default:
                    break
            }
            break;
        case "questionkeywords":
            ResultComponent = QuestionkeywordsComponent;
            break;
        case "questionsentence":
            ResultComponent = QuestionSentenceComponent;
            break;
        case "research":
            ResultComponent = ResearchComponent;
            break;
        case "sortlist":
            ResultComponent = SortlistComponent;
            break;
        case "table":
            ResultComponent = TableComponent;
            break;
        case "exercisegroup":
            ResultComponent = ExerciseGroupComponent;
            break;
        default:
            ResultComponent = DefaultComponent
    }
    extraParams = {...props, ...extraParams};
    return (
        <ResultComponent {...extraParams}/>
    )
}
